angular.module('inspecciones')
    .controller('evoluciondamageController', ['$rootScope', '$scope', '$location', '$route', '$routeParams', 'inspeccionesService', 'infraestructurasAdminService', 'authenticationInfo', 'authenticationService',
        function ($rootScope, $scope, $location, $route, $routeParams, inspeccionesService, infraestructurasAdminService, authenticationInfo, authenticationService) {

            $scope.authentication = authenticationInfo;
            //$scope.InfraestructuraId = $routeParams.idInfraestructura;           

            $scope.inspeccionId = $routeParams.inspeccionId;

            $scope.dañoId = $routeParams.id;

            inspeccionesService.getDañosPorCodigo($scope.dañoId)
                .then(function (response) {
                    $scope.daños = response.data;
                    $scope.Codigo = $scope.daños[0].Codigo;

                    inspeccionesService.getEvoluciones()
                        .then(function (respuestaEv) {
                            $scope.evoluciones = respuestaEv.data;

                            var labelsEv = $scope.daños.map(function (item) {
                                return formatDate(item.FechaInspeccion);
                            });

                            var valoresEv = $scope.daños.map(function (item) {
                                return item.Evolucion;
                            });

                            // Crear mapa de id -> descripcion
                            var etiquetasEvolucion = {};
                            $scope.evoluciones.forEach(function (e) {
                                etiquetasEvolucion[e.Id] = e.Descripcion;
                            });

                            var ctx = document.getElementById('graficoEvolucionDanios').getContext('2d');
                            var myLineChart = new Chart(ctx, {
                                type: 'line',
                                data: {
                                    labels: labelsEv,
                                    datasets: [{
                                        label: 'Evolución del daño',
                                        data: valoresEv,
                                        fill: false,
                                        borderColor: 'blue',
                                        tension: 0.1
                                    }]
                                },
                                options: {
                                    responsive: true,
                                    scales: {
                                        y: {
                                            min: 1,
                                            max: 5,
                                            ticks: {
                                                stepSize: 1,
                                                callback: function (value) {
                                                    return etiquetasEvolucion[value] || '';
                                                }
                                            }
                                        }
                                    },
                                    plugins: {
                                        tooltip: {
                                            callbacks: {
                                                label: function (context) {
                                                    var valor = context.raw;
                                                    var descripcion = etiquetasEvolucion[valor] || valor;
                                                    return 'Evolución: ' + descripcion;
                                                }
                                            }
                                        }
                                    }
                                }
                            });
                        });

                    inspeccionesService.getGravedades()
                        .then(function (respuestaGr) {
                            $scope.gravedades = respuestaGr.data; // array de strings

                            // 1. Construir mapa texto -> número
                            var mapaGravedad = {};
                            $scope.gravedades.forEach(function (descripcion, index) {
                                mapaGravedad[descripcion] = index + 1;
                            });

                            // 2. Fechas
                            var labelsGr = $scope.daños.map(function (item) {
                                return formatDate(item.FechaInspeccion);
                            });

                            // 3. Valores convertidos a números
                            var valoresGr = $scope.daños.map(function (item) {
                                return mapaGravedad[item.Gravedad];
                            });

                            // 4. Inverso: número -> texto
                            var etiquetasInversas = {};
                            Object.keys(mapaGravedad).forEach(function (desc) {
                                etiquetasInversas[mapaGravedad[desc]] = desc;
                            });

                            // 5. Gráfico
                            var ctx = document.getElementById('graficoGravedadDanios').getContext('2d');
                            var myLineChart = new Chart(ctx, {
                                type: 'line',
                                data: {
                                    labels: labelsGr,
                                    datasets: [{
                                        label: 'Evolución de la Gravedad del daño',
                                        data: valoresGr,
                                        fill: false,
                                        borderColor: 'green',
                                        tension: 0.1
                                    }]
                                },
                                options: {
                                    responsive: true,
                                    scales: {
                                        y: {
                                            min: 1,
                                            max: $scope.gravedades.length,
                                            ticks: {
                                                stepSize: 1,
                                                callback: function (value) {
                                                    return etiquetasInversas[value] || '';
                                                }
                                            }
                                        }
                                    },
                                    plugins: {
                                        tooltip: {
                                            callbacks: {
                                                label: function (context) {
                                                    var valor = context.raw;
                                                    var descripcion = etiquetasInversas[valor] || valor;
                                                    return 'Gravedad: ' + descripcion;
                                                }
                                            }
                                        }
                                    }
                                }
                            });
                        });

                });



            function formatDate(fechaStr) {
                var fecha = new Date(fechaStr);
                var dia = String(fecha.getDate()).padStart(2, '0');
                var mes = String(fecha.getMonth() + 1).padStart(2, '0');
                var anio = fecha.getFullYear();
                return dia + '-' + mes + '-' + anio;
            }


            $scope.volver = function () {
                $location.path('/damages/' + $scope.inspeccionId + '/' + $scope.dañoId);
                $rootScope.inspeccionUrl = true;
                $rootScope.damageUrl = true;
            }

            $scope.verCategorias = function () {
                $rootScope.inspeccionUrl = false;
                $rootScope.parteUrl = false;
                $rootScope.parteUrl = false;
                $location.path('/categorias');
            };
        }
    ]);